/**
 * 本地存储
 */
import HelperCore from "./core";
import EE from "@src/common/event";

const Local = {
  /**
   * 存储数据
   * @param {String} key 
   * @param {Mixed} value 
   * @param {number|date|string} expire 默认不过期 number: 天数 date: 过期时间戳 string: (today 仅当天有效)
   */
  setItem(key, value, expire) {
    let type = typeof value;

    if (expire) {
      let now = new Date();
      if (expire == "today") {
        now = HelperCore.getNextDay(now);
        expire = now.getTime();
      }
      else if (typeof expire == "object" && expire.getTime) {
        expire = expire.getTime();
      }
      else if (typeof expire == "number") {
        now.setDate(now.getDate() + expire);
        expire = now.getTime();
      }
    }

    localStorage.setItem(key, JSON.stringify({
      type,
      value,
      expire,
    }));
  },
  getItem(key) {
    let value = localStorage.getItem(key);
    if (!value) {
      return value;
    }
    try {
      value = JSON.parse(value);
      // 是否有有效期，是否已过期
      if (value.expire && value.expire < Date.now()) {
        this.removeItem(key);
        return null;
      }
      return value.value;
    } catch (e) { }
    return null;
  },
  removeItem(key) {
    localStorage.removeItem(key);
  },

  /**
   * 种cookie
   * @param {String} cookieName
   * @param {String} cookieValue
   * @param {Number} day         有效时长，单位为日
   * @param {Object} options     其它属性
   * @example
   *     Local.setCookie("pri", "4", { path : "/" });    // 默认365天
   *     Local.setCookie("pri", "4", { path : "/" }, -1);      // 设置一个过期的cookie，即删除cookie
   *     option : {
   *         domain : "xxx",
   *         path : "xxx",
   *         secure : "xxx"
   *     }
   */
  setCookie(cookieName, cookieValue, options, day) {
    options = options || {};

    let expiredays = parseFloat(day) || 365;
    let exdate = new Date();
    exdate.setTime(exdate.getTime() + expiredays * 86400000);
    let cookieVal = cookieName + "=" + escape(cookieValue) + ";expires=" + exdate.toGMTString();

    cookieVal += options.domain ? ';domain=' + options.domain : '';
    cookieVal += options.path ? ';path=' + options.path : ';path=/';
    cookieVal += options.secure ? ';secure=' + options.secure : '';

    document.cookie = cookieVal;
  },
  /**
   * 取cookie
   * @param  {String} cookieName
   * @return {String} cookieValue
   */
  getCookie(cookieName) {
    let result = new RegExp(
      '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)',
    ).exec(document.cookie);
    if (result) {
      result = result[1];
      try {
        result = decodeURIComponent(result);
      } catch (e) { }
    }
    return result || '';
  },
  /**
   * 清除过期数据
   */
  clear() {
    try {
      Object.keys(localStorage).forEach(key => {
        this.getItem(key);
      });
    } catch (e) { }
  },

  /**
   * session 存储数据
   * @param {String} key 
   * @param {Mixed} value 
   * @param {number|date|string} expire 默认不过期 number: 天数 date: 过期时间戳 string: (today 仅当天有效)
   */
  setSessionItem(key, value) {
    let type = typeof value;

    sessionStorage.setItem(key, JSON.stringify({
      type,
      value,
    }));
  },
  getSessionItem(key) {
    let value = sessionStorage.getItem(key);
    if (!value) {
      return value;
    }
    try {
      value = JSON.parse(value);
      return value.value;
    } catch (e) { }
    return null;
  },
  removeSessionItem(key) {
    sessionStorage.removeItem(key);
  },
  clearUserInfo() {
    this.removeItem("NW_LOGIN_DATA");
    const cookieOptions = { path: "/", domain: location.host.slice(location.host.indexOf(".")) };
    // access-token 改为 httponly 20220616
    // this.setCookie("access-token", "", cookieOptions, -1);
    this.setCookie("access-token-status", "", cookieOptions, -1);
  },
  /**
   * 新老用户 new: 当天注册的用户 old: 老用户
   * @param {Object} user
   */
  getUserStatus(user) {
    if (!user) {
      return '';
    }
    const { addtime } = user;
    if (!addtime) {
      return '';
    }
    return HelperCore.formatDate(new Date(addtime * 1000), "yyyyMMdd") == HelperCore.formatDate(new Date(), "yyyyMMdd") ? "new" : "old";
  },
  getUserInfoSync() {
    let userInfo = this.getItem("NW_LOGIN_DATA");
    if (userInfo) {
      return userInfo;
    }
    return null;
  },
  setUserInfo(userLoginSuccRes) {
    // 登录成功后的数据 可能是游客也可能是正式登录用户
    this.setItem("NW_LOGIN_DATA", userLoginSuccRes);
    // 将游客注册失败次数限制清零
    this.removeItem('NW_GUEST_RELOAD');
    EE.emit('login', userLoginSuccRes);
  },

  init() {
    if (!HelperCore.IS_PROD) {
      window.Local = Local;
    }
  },
}

Local.init();

export default Local;